import { render, staticRenderFns } from "./columns-settings-dialog.vue?vue&type=template&id=de5b12f4&scoped=true&"
import script from "./columns-settings-dialog.vue?vue&type=script&lang=ts&"
export * from "./columns-settings-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./columns-settings-dialog.vue?vue&type=style&index=0&id=de5b12f4&lang=scss&scoped=true&"
import style1 from "./columns-settings-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5b12f4",
  null
  
)

export default component.exports